import { IProductOption } from '../../../interfaces/Product.interfaces';
import { customAxios } from '../../common/customAxios';

export const getProductOptions = (): Promise<IProductOption[]> => {
  return customAxios.get('/product-options');
};
